import { render, staticRenderFns } from "./Purchase-Order.vue?vue&type=template&id=42fb1b15&scoped=true&"
import script from "./Purchase-Order.vue?vue&type=script&lang=js&"
export * from "./Purchase-Order.vue?vue&type=script&lang=js&"
import style0 from "./Purchase-Order.vue?vue&type=style&index=0&id=42fb1b15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fb1b15",
  null
  
)

export default component.exports